import { render, staticRenderFns } from "./make-a-report.vue?vue&type=template&id=52257de5&scoped=true"
import script from "./make-a-report.vue?vue&type=script&lang=js"
export * from "./make-a-report.vue?vue&type=script&lang=js"
import style0 from "./make-a-report.vue?vue&type=style&index=0&id=52257de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52257de5",
  null
  
)

export default component.exports